const WhyUs = () => {
    return (
        <section className="reveal fade-in">
            <div className="container">
                <h3 className="section-title">Why Choose Us</h3>
                <p className="text-primary">[ Turning Clicks into Clients ]</p>
                <div className="row justify-center row-content">
                    <div className="col-3 col-md-6 col-xs-12">
                        <div className="gap-fix">
                            <p><i className="fa-solid fa-pen x4"></i></p>
                            <h2>Best web designs</h2>
                            <p>Awesome web interface and, we make your web application look awesome and attractive.</p>
                        </div>
                    </div>
                    <div className="col-3 col-md-6 col-xs-12">
                        <div className="gap-fix">
                            <p><i className="fa-sharp-duotone fa-solid fa-object-ungroup x4"></i></p>
                            <h2>SEO optmization</h2>
                            <p>Our technologies are designed to target your market audience. Turning clicks into clients</p>
                        </div>
                    </div>
                    <div className="col-3 col-md-6 col-xs-12">
                        <div className="gap-fix">
                            <p><i className="fa-solid fa-layer-group x4"></i></p>
                            <h2>Expert Installation</h2>
                            <p>Expert installation of websites and application considering all devices andriod, ioS and desktop.</p>
                        </div>
                    </div>
                    <div className="col-3 col-md-6 col-xs-12">
                        <div className="gap-fix">
                            <p><i className="fa-solid fa-eraser x4"></i></p>
                            <h2>Ongoing Maintenance</h2>
                            <p>Dedicated to preserve the brilliance and functionality of your website or app.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default WhyUs;